import * as angular from 'angular';

import { ComponentDefinition } from '../../../models';
import { HeaderInfo } from '../HeaderInfo';

class PrintHeaderController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;

    readonly headerInfo: HeaderInfo; // Assumed

    static $inject = [];
}

export const wtPrintHeader: ComponentDefinition = {
    componentId: 'wtPrintHeader',
    controller: PrintHeaderController,
    template: require('./printHeader.component.html'),
    controllerAs: 'vm',
    bindings: {
        headerInfo: '<'
    }
};